import { Platform } from 'react-native';

// Matches theme.css --shadow-* variables
export const Shadows = {
  sm: Platform.select({
    web: { boxShadow: '0 1px 0 rgba(16,24,40,0.04)' },
    default: {
      shadowColor: '#101828',
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 0.04,
      shadowRadius: 0,
      elevation: 1,
    },
  }),
  base: Platform.select({
    web: { boxShadow: '0 1px 2px rgba(16,24,40,0.06), 0 4px 12px -4px rgba(16,24,40,0.08)' },
    default: {
      shadowColor: '#101828',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.08,
      shadowRadius: 6,
      elevation: 3,
    },
  }),
  md: Platform.select({
    web: { boxShadow: '0 2px 6px rgba(16,24,40,0.08), 0 8px 20px -6px rgba(16,24,40,0.10)' },
    default: {
      shadowColor: '#101828',
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 0.10,
      shadowRadius: 10,
      elevation: 5,
    },
  }),
  lg: Platform.select({
    web: { boxShadow: '0 4px 14px rgba(16,24,40,0.10), 0 16px 32px -12px rgba(16,24,40,0.14)' },
    default: {
      shadowColor: '#101828',
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 0.14,
      shadowRadius: 20,
      elevation: 10,
    },
  }),
};
